let user = require('../../../actions/user');
let orders = require('../../../actions/account/orders');
let ordersList = require('../../../actions/account/orders-list');
let utils = require('../../../actions/utils');
let currentOrderGroups = require('../../groups/account/current-order');
let customOrderGroups = require('../../groups/custom-order');
let customOrder = require('../../../actions/custom-order');
let accountOrder = require('../../../actions/account/current-order');
let error = require('../../../actions/error');
let content = require('../../../actions/layout/content');
let { raiseEventsOnOrderLoaded } = require('../../../signals/groups/analytics');
let { usingLock } = require('../../../signals/utils');

let getExportResults = [
    [
        accountOrder.isNeedToGetExportResults,
        {
            yes: [
                ...usingLock(['account', 'orders', 'currentOrder', 'exportResultsLock'], [
                    [
                        accountOrder.getExportResults,
                        {
                            success: [
                                accountOrder.updateOrder(['exportResult', 'hasBitrixLeads'])
                            ],
                            orderChanged: [],
                            locked: [],
                            error: [
                                error.internalError('accountOrder.getExportResults')
                            ]
                        }
                    ]
                ])
            ],
            no: []
        }
    ]
];

let getOrderGroup = [
    [
        orders.getOrder,
        {
            success: [
                orders.setCurrentOrder,
                orders.resetUserSelect,
                orders.resetManagerSelect,
                orders.resetAddParams,
                orders.setOrderAmount,
                utils.unset(['order', 'cities', 'tab']),
                utils.setPopupVisibility('datepicker', ['order', 'popups', 'datepicker', 'isOpen']),
                utils.setPopupVisibility('datepicker2', ['order', 'popups', 'datepicker2', 'isOpen']),
                customOrder.setShouldPersistToLocalStorage(false),
                ...customOrderGroups.setOrderParametersGroup,
                customOrder.setComputedFields,
                ...currentOrderGroups.initSelectedParamsFromOrderGroup
                // ...getStatistic
            ],
            notFound: [
                error.notFound('orders.getOrder')
            ],
            error: [
                error.internalError('orders.getOrder')
            ]
        }
    ]
];

module.exports = {
    getExportResults,

    getOrderState: [
        ...usingLock(['account', 'orders', 'getStateLock'], [
            [
                accountOrder.getOrderState,
                {
                    success: [
                        accountOrder.updateOrder(['stateId']),
                        ...getExportResults
                    ],
                    dontNeed: [],
                    error: [ error.internalError('accountOrder.getOrderState') ]
                }
            ]
        ])
    ],

    getHasBitrixLeads: [
        ...usingLock(['account', 'orders', 'getHasBitrixLeads'], [
            [
                accountOrder.getHasBitrixLeads,
                {
                    success: [
                        accountOrder.updateOrder(['hasBitrixLeads'])
                    ],
                    dontNeed: [],
                    error: [ error.internalError('accountOrder.getHasBitrixLeads') ]
                }
            ]
        ])
    ],

    getOrder: [
        ...getOrderGroup
    ],

    selectOrder: [
        content.setIsLoading(true),
        utils.queryOrderRedirect(['account', 'orders', 'computed', 'query']),
        ...getOrderGroup,
        content.setIsLoading(false),
        ...raiseEventsOnOrderLoaded
    ],

    // заполняем данные для локального черновика
    setLocalOrderData: [
        utils.set(['account', 'orders', 'list', 'isAllLoaded'], true),
        orders.initAccountState,
        ...customOrderGroups.getAvailableParametersGroup,
        customOrder.setComputedFields,
        [
            accountOrder.getDocumentTypes,
            {
                success: [
                    accountOrder.updateOrder(['necessaryDocuments'])
                ],
                error: [
                    error.internalError('accountOrder.getDocumentTypes')
                ]
            }
        ],
        utils.set(['account', 'orders', 'list', 'initialized'], true)
    ],

    // заполняем список заказов и данные заказа
    updateOrderData: [
        [
            user.isUnauthorized,
            {
                no: [
                    [
                        ordersList.getOrdersList,
                        {
                            success: [
                                ordersList.addOrders,
                                [
                                    ordersList.isAnyOrders,
                                    {
                                        yes: [
                                            ordersList.setOrderIdArgsIfNotSet,
                                            ...getOrderGroup,
                                            utils.queryOrderRedirect(['account', 'orders', 'computed', 'query'])
                                        ],
                                        no: []
                                    }
                                ]
                            ],
                            notFound: [],
                            error: [
                                error.internalError('ordersList.getOrdersList'),
                                utils.set(['account', 'orders', 'list', 'isError'], true)
                            ]
                        }
                    ]
                ],
                yes: [
                    utils.set(['account', 'orders', 'list', 'isAllLoaded'], true),
                    orders.initAccountState,
                    ...customOrderGroups.getAvailableParametersGroup,
                    customOrder.setComputedFields,
                    [
                        accountOrder.getDocumentTypes,
                        {
                            success: [
                                accountOrder.updateOrder(['necessaryDocuments'])
                            ],
                            error: [
                                error.internalError('accountOrder.getDocumentTypes')
                            ]
                        }
                    ]
                ]
            }
        ],
        utils.set(['account', 'orders', 'list', 'initialized'], true)
    ],

    getManagersList: [
        [
            orders.getManagers,
            {
                success: [
                    utils.setFromArgsToState('managers', ['account', 'orders', 'managers'])
                ],
                error: []
            }
        ]
    ],

    getUsersList: [
        [
            orders.getUsers,
            {
                success: [
                    utils.setFromArgsToState('users', ['account', 'orders', 'users'])
                ],
                error: []
            }
        ]
    ]
};



// WEBPACK FOOTER //
// ./signals/groups/account/index.js